var tip = {
	show: function(elm, message)
	{
		if(elm.next().hasClass('tip'))
		{
			elm.next().html(message).fadeIn(500);
		}
		else
		{
			elm.after('<div class="tip">' + message + '</div>');
			var tip = elm.next();
			tip.css({
				top: elm.position().top + - 5,
				left: elm.position().left + elm.width() + 27
			});
			tip.fadeIn(500);
		}
	},
	hide: function(elm)
	{
		elm.next().fadeOut(500);
	}
};